import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import {
  Badge,
  Breadcrumb,
  Button,
  Card,
  Form,
  Table,
} from "@themesberg/react-bootstrap";
import { confirmDeleteToast, sendError, sendSuccess } from "../helpers/Helper";
import { Model } from "../components/Model";
import { Textbox } from "../components/Textbox";
import { SelectBox } from "../components/SelectBox";
import { API_URL_ENDPOINT } from "../appsetting";
import TextEditor from "../components/TextEditor";
import CustomPagination from "../components/CustomPagination";
import { useNavigate } from "react-router-dom";
import { Routess } from "../Routes/routes";
import {
  Avatar,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useApi } from "../helpers/useApi";
import { Accordion } from "react-bootstrap";

export const Roles = () => {
  const callApi = useApi();
  const [openModel, setOpenModel] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(0);
  const [selectedRoleName, setSelectedRoleName] = useState('');
  const [checkedIds, setCheckedIds] = useState([]);
  const navigate = useNavigate();
  const methods = useForm();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
    watch,
    setValue,
  } = methods;
  const selectedType = watch("type");

  const [dataLoading, setDataLoading] = useState(false);
  const [data, setData] = useState([]);
  const [permissionData, setPermissionData] = useState([]);

  useEffect(() => {
    getData();
    setSelectedGroup("198534f0-146a-4f16-a2d7-97cd6a72b2fe"); // By Defalt Admin Remain Selected
  }, []);

  useEffect(() => {
    setCheckedIds(getPermissionIds(selectedGroup));
  }, [selectedGroup]);

  const getPermissionIds = (id) => {
    const allRoles = data?.flatMap(group => group.roles) || [];
    // Find the selected role
    const selectedRole = allRoles.find(role => role.id === id);
    setSelectedRoleName(selectedRole?.name)
    return selectedRole ? selectedRole.permissions : [];
  };

  const handleCheckboxChange = (id) => {
    setCheckedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const getData = async (cp = null) => {
    try {
      setDataLoading(true);
      const response = await callApi(`${API_URL_ENDPOINT.Users}/role`);
      if (response.status) {
        setData(response.data);
        getPermissionData()
      }
    } catch {
      setData([]);
    } finally {
      setDataLoading(false);
    }
  };

  const onSubmit = async (data) => {
    try {
      const payload = {
        roleCategory: data.roleGroup,
        roleName: data.rolename,
      };
      const response = await callApi(`${API_URL_ENDPOINT.Users}/role`, {
        method: "POST",
        data: payload,
      });
      if (response.status) {
        reset();
        setOpenModel(false);
        getData();
        sendSuccess(response.message);
      } else {
        throw Error(response.message || "Something Went Wrong");
      }
    } catch (ex) {
      sendError(ex.message);
    }
  };

  const getPermissionData = async () => {
    try {
      setDataLoading(true);
      const response = await callApi(API_URL_ENDPOINT.Users + "/permissions");
      if (response.status) {
        setPermissionData(response.data);
      }
    } catch {
      setData([]);
    } finally {
      setDataLoading(false);
    }
  };

  const updateUserGroupPermission = async () => {
    try {
      const response = await callApi(
        `${API_URL_ENDPOINT.Users}/permissions/${selectedGroup}`,
        {
          method: "POST",
          data: checkedIds,
        }
      );
      if (response.status) {
        getData();
        sendSuccess(response.message);
      } else {
        throw Error(response.message || "Something Went Wrong");
      }
    } catch (ex) {
      sendError(ex.message);
    }
  };

  const handleDelete = () => {
    confirmDeleteToast(() => {
      sendSuccess("Deleted successfully!");
    });
  };

  return (
    <>
      <Model show={openModel} size={"md"}>
        <h5>Add New Role</h5>
        <FormProvider {...methods}>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-md-12">
                <Form.Group className="mb-3">
                  <SelectBox
                    Label="Role Group"
                    name={"roleGroup"}
                    validationRules={{ required: "Role Group is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  >
                    <option value={""}>Select Role Group</option>
                    <option value={"Branch"}>Branch Roles</option>
                    <option value={"KYC"}>KYC Verifier Roles</option>
                    <option value={"Support"}>Support Roles</option>
                  </SelectBox>
                </Form.Group>
              </div>
              <div className="col-md-12">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Role Title"
                    name={"rolename"}
                    Placeholder="Enter Role Title"
                    validationRules={{ required: "Role is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
            </div>
            <div className="text-end">
              <Button
                type="Button"
                className="me-2"
                variant="outline-danger"
                onClick={() => setOpenModel(false)}
              >
                Close
              </Button>
              <Button type="submit" disabled={isSubmitting} variant="success">
                Save Changes
              </Button>
            </div>
          </Form>
        </FormProvider>
      </Model>

      <div className="justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item>Website</Breadcrumb.Item>
            <Breadcrumb.Item active>Roles And Permission</Breadcrumb.Item>
          </Breadcrumb>
          <div className="d-flex align-items-center justify-content-between">
            <h4 className="mb-0">Roles And Permission</h4>
            {/* <p className="mb-0">
              Dozens of reusable components built to provide buttons, alerts, popovers, and more.
            </p> */}
            <div>
              <Button
                variant="primary"
                className="m-1"
                onClick={() => {
                  setOpenModel(true);
                  reset();
                }}
              >
                Add New Role
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* <PageTrafficTable /> */}
      <Card border="light" className="shadow-sm mb-4">
        <Card.Body className="">
          {dataLoading ? (
            <div className="text-center my-3">
              <span
                className="spinner-border text-primary"
                role="status"
              ></span>
              {/* <p>Loading News & Events...</p> */}
            </div>
          ) : (
            <div className="row">
              <div className="col-md-3 border p-0">
                <Accordion defaultActiveKey="0" className="role-accordion">
                  {data?.length > 0 ? (
                    data.map((roleCategory, sIndex) => {
                      const roles = roleCategory?.roles || [];

                      // Show single role directly (no Accordion)
                      if (roles.length === 1) {
                        const item = roles[0];
                        return (
                          <List
                            className="p-0 mb-2"
                            component="nav"
                            aria-label="single role item"
                            key={sIndex}
                          >
                            <ListItemButton
                              selected={selectedGroup == item.id}
                              onClick={() => setSelectedGroup(item.id)}
                            >
                              <ListItemText
                                primary={`${item.name}`}
                                slotProps={{
                                  primary: { sx: { fontSize: 16, fontWeight:'normal', color:"#333" } },
                                }}
                              />
                            </ListItemButton>
                          </List>
                        );
                      }

                      // Show multiple roles in Accordion
                      return (
                        <Accordion.Item
                          eventKey={sIndex.toString()}
                          key={sIndex}
                        >
                          <Accordion.Header>
                            <div className="w-100 d-flex justify-content-between me-3">
                              {roleCategory.category}
                            </div>
                          </Accordion.Header>
                          <Accordion.Body
                            className="p-0"
                            style={{ background: "#ededed" }}
                          >
                            <List
                              className="p-0"
                              component="nav"
                              aria-label="role list"
                            >
                              {roles.length > 0 ? (
                                roles.map((item, index) => (
                                  <ListItemButton
                                    key={index}
                                    selected={selectedGroup == item.id}
                                    onClick={() => setSelectedGroup(item.id)}
                                  >
                                    <ListItemText
                                      primary={item.name}
                                      slotProps={{
                                        primary: { sx: { fontSize: 14 } },
                                      }}
                                    />
                                  </ListItemButton>
                                ))
                              ) : (
                                <p className="px-3 py-2">
                                  No User Group Found.
                                </p>
                              )}
                            </List>
                          </Accordion.Body>
                        </Accordion.Item>
                      );
                    })
                  ) : (
                    <div className="text-muted">No Role Found.</div>
                  )}
                </Accordion>
              </div>
              <div className="col-md-9 mb-3">
                <div className="row">
                  {selectedGroup !== 0 &&
                    (selectedGroup === "198534f0-146a-4f16-a2d7-97cd6a72b2fe" ? (
                      <h6 className="mt-2 text-center text-muted">
                        No Permission Needed for Super Admin
                      </h6>
                    ) : (
                      <>
                        <h6 className="mt-2">Assign Permissions for {selectedRoleName}</h6>

                        {permissionData.map((item, i) => (
                          <div key={i} className="col-md-12 mb-3">
                            <div className="border rounded p-3 shadow-sm bg-light">
                              <label className="fw-bold mb-2 d-block">
                                {item.category}
                              </label>

                              <div className="row">
                                {item.permissions.map((permission, j) => (
                                  <div key={j} className="col-md-6 col-xl-4">
                                    <div className="form-check mb-2">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`checkid${permission}`}
                                        checked={checkedIds.includes(
                                          permission
                                        )}
                                        onChange={() =>
                                          handleCheckboxChange(permission)
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        style={{fontSize:12}}
                                        htmlFor={`checkid${permission}`}
                                      >
                                        {permission}
                                      </label>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        ))}

                        <div className="col-12 text-end">
                          <Button
                            onClick={updateUserGroupPermission}
                            className="mt-3"
                          >
                            Save Changes
                          </Button>
                        </div>
                      </>
                    ))}
                </div>
              </div>
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
};
